if (document.querySelector('.sc-product-list')) {
  const productListSection = document.querySelector('.sc-product-list');
  const productNumberText = document.querySelector('.sc-product-list .product-list__total p');
  const form = document.querySelector('form.product-filter__form');

  const filterButtons = document.querySelectorAll('.product-filter .dropdown__list-item input');
  const clearFilters = document.querySelectorAll('.product-filter__reset-btn, .product-list__reset-btn');
  const productList = document.querySelector('.product-list__list');

  form.addEventListener('submit', (event) => {
    event.preventDefault();
  });
  const getSelectedItems = (selector) =>
    [...document.querySelectorAll(selector)].filter((input) => input.checked).map(({ value }) => value);

  const loadMoreAxios = (pageNumber = 1) => {
    document.querySelector('.sc-product-list .product-filter').scrollIntoView({ behavior: 'smooth', block: 'start' });

    const formDataInput = new FormData();
    formDataInput.append('action', 'shopCategoryLoadMore');
    formDataInput.append('primary', productListSection.dataset.categories);
    const checkedValues = [...document.querySelectorAll('.product-filter__filter .dropdown__list input:checked')].map(
      (input) => input.value,
    );

    formDataInput.append('filters', checkedValues.join(','));

    formDataInput.append('order', getSelectedItems('.sort-dropdown__list input'));
    formDataInput.append('per_page', getSelectedItems('.pagination__footer input'));
    formDataInput.append('number', pageNumber);
    axios
      .post(localData.apiURL, formDataInput, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        let url = '';
        ['filters', 'order', 'number', 'per_page'].forEach((item) => {
          if (formDataInput.get(item)) {
            url += `${item}=${formDataInput.get(item)}&`;
          }
        });
        window.history.pushState({ urlPath: window.location.href }, null, `?${url}`);
        productList.innerHTML = response.data.products;
        productListSection.querySelector('.product-list').classList.toggle('no-product-found', !response.data.number);
        document.querySelector('.product-list__footer').innerHTML = response.data.pagination;
        productNumberText.innerHTML = response.data.number_product;
      })
      .finally(() => {
        dropdownGlobalHandler();
      })
      .catch((err) => {
        console.error(err);
      });
  };
  if (clearFilters) {
    clearFilters.forEach((clearFilter) => {
      clearFilter.addEventListener('click', () => {
        filterButtons.forEach((button) => {
          button.checked = false;
        });
        setTimeout(() => {
          loadMoreAxios();
        }, 200);
      });
    });
  }
  filterButtons.forEach((filter) => {
    filter.addEventListener('click', (event) => {
      if (event.isTrusted) {
        document.querySelectorAll(`input[value="${event.target.value}"]`).forEach((el) => {
          if (el.id !== event.target.id) {
            el.click();
          }
        });
        loadMoreAxios();
      }
    });
  });

  const sortButtons = document.querySelectorAll('.sort-dropdown__list input');
  if (sortButtons) {
    sortButtons.forEach((sortBy) => {
      sortBy.addEventListener('click', () => {
        loadMoreAxios();
      });
    });
  }
  // clear each filter click
  attachEvent('button.product-filter__selected, [data-reset-filter]', 'click', () => {
    setTimeout(() => {
      loadMoreAxios();
    }, 200);
  });
  // pagination clicker and number of products on list
  attachEvent('.product-list__footer .page-numbers, .pagination__footer input', 'click', (event) => {
    event.preventDefault();
    loadMoreAxios(Number(event.target.closest('a')?.dataset?.page ?? 1));
  });
  // clear each cloud filter click
  attachEvent('.product-filter__selected', 'click', (event) => {
    const { filterId } = event.target.dataset;
    const input = document.querySelector(
      `.filter-modal__body input[type="checkbox"][value="${parseInt(filterId.replace('filter-', ''), 10)}"]`,
    );
    if (input && input.checked && !event.isTrusted) {
      input.click();
    }
  });

  // Scroll to active item
  const scrollToActiveCategory = () => {
    if (windowWidth() < breakpointMd) {
      const activeCategory = document.querySelector('.product-filter__category--link.is-active');
      const container = document.querySelector('.product-filter__category-filter');

      if (!activeCategory) return;

      container.scrollTo({
        left: activeCategory.offsetLeft - 16,
        behavior: 'smooth',
      });
    }
  };

  scrollToActiveCategory();
}
